import { render } from "./CommentComp.vue?vue&type=template&id=7b54317e&scoped=true"
import script from "./CommentComp.vue?vue&type=script&lang=js"
export * from "./CommentComp.vue?vue&type=script&lang=js"

import "./comment-comp-responsive.css?vue&type=style&index=0&lang=css&external"
import "./CommentComp.vue?vue&type=style&index=1&id=7b54317e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b54317e"]])

export default __exports__